// 万众知识库
const Dm = () => import('@/views/dm/Index')

export default [
  {
    path: '/dm',
    component: Dm,
    name: 'dm',
    meta: {
      title: 'DM单张',
      keepAlive: true
    }
  }
]


// WEBPACK FOOTER //
// ./src/router/dm.js